module.exports = __webpack_public_path__ + "static/media/cedula_frente@2x.0aaf936b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/cedula_frente@2x.jpg
// module id = 642
// module chunks = 0